import { SelectBox, TextArea, TextBox, DateBox } from "devextreme-react";
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors"
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import CheckBox from 'devextreme-react/check-box';
import dayjs from "dayjs";
import { factoryProcessClaimsTemplateTypes } from "../../../../../Constantes/documentataionRequestTypes";
import { selectWorkshopSearchResults } from "../../../../../redux/workshopSearch/selectors";
import { CodeTemplates, FactoryProcessCodeTemplates, FactoryProcessTemplates } from "../../../../../Constantes/codeDocumentationTemplates";

function InputWrapper(props){
    const {classes, label} = props;
        return(
            <div className="dx-field">
            <label className={classes.label}>{label}</label> 
                <div style={{width:"100%"}} className="dx-field-value">
                    {props.children}
                </div>
        </div>
        )
    }

function ClaimsRequestForm(props){
    const { classes, onChange, dataForm, template } = props;
    const dispatch = useDispatch();
    const types = useSelector(selectTaxonomyTemplates);
    const typesLoading = useSelector(selectTaxonomyTemplatesLoading)
    const [type, setType] = useState(dataForm?.templateCode)
    const subTypes = [{name: "DRIVER´S", code: "factory_process_maintenance_claim"}, {name: "DRIVEON", code: "factory_process_maintenance_claim_driveon"}]
    const workshopSearchResults = useSelector(selectWorkshopSearchResults)

    useEffect(()=>{
        dispatch(getTaxonomyTemplates({query: "?templateCode=" + template.code}))
    },[template])

    useEffect(()=>{
        if(type && types.length > 0){
        onChange("templateId", getTemplateIdFromCode(type))
        }
    },[type, types])

    function changeDate(field, date){
        let stringDate = null; 
        if(date){
        stringDate = dayjs(date).format()
        }
        onChange(field,stringDate)
    }

    function setPhoneNumber(e){
        let nonDigitsRegExp = /\D/gm;
        const filteredNumber = e.value.replace(nonDigitsRegExp, "")
        onChange("phoneNumber", filteredNumber)
    }

    function setNotes(e){
        const filteredText = deleteStrangeCharacters(e.value); 
        onChange("notes", filteredText)
       
    }

    function getTemplateIdFromCode(code){
        const result = types.find(type=> type.code === code)
        if(result){
            return result.id
        }
    }

    function changeUrgent(value){
        onChange("urgent", value)
        if(value){
            onChange("subType", null)
            onChange("driveOn", false)
        }
    }

    function changeDriver(value){
        if(dataForm?.templateCode === FactoryProcessTemplates.FACTORY_PROCESS_MAINTENANCE_CLAIM){
            if(value){
                onChange("urgent", false)
                onChange("subType", "factory_process_maintenance_claim_driveon")
                onChange("driveOn", value)
            } else {
                onChange("subType", null)
                onChange("driveOn", false)
            }
        }
    }

    useEffect(()=>{
        if(dataForm.workshop){
            onChange("workshop", null)
        }    
    },[workshopSearchResults])

    useEffect(()=>{
        if(dataForm?.templateCode !== FactoryProcessTemplates.FACTORY_PROCESS_MAINTENANCE_CLAIM)
        {
            onChange("subType", null)
            onChange("driveOn", false)
        }

    },[dataForm?.templateCode])

    return(
        <div className={classes.containers} id="documentation-request-form">
            <InputWrapper classes={classes} label={"Tipología"}>
                <SelectBox disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => { setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} height={25}></SelectBox>
            </InputWrapper>

            <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Nombre"}>
                    <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Apellidos"}>
                    <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
            </div>            
            <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Correo electrónico"}>
                    <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Móvil"}>
                    <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>                     
            </div>        
            <InputWrapper classes={classes} label={"Taller"}>
                {workshopSearchResults ?
                    <SelectBox placeholder=" " key={"workshop"} name="workshop" value={dataForm?.workshop} onValueChanged={(e) => onChange("workshop",e.value)} dataSource={workshopSearchResults} valueExpr={"name"} displayExpr={"name"} className={classes.controlers} height={25} />
                    : <TextBox key={"workshop"} name="workshop" value={dataForm?.workshop} onValueChanged={(e) => onChange("workshop",e.value)} className={classes.controlers} height={25}></TextBox>
                }
                </InputWrapper>
            <InputWrapper classes={classes} label={"Motivo Inmovil."}>
                <TextBox key={"immobilizationReason"} name="immobilizationReason" value={dataForm?.immobilizationReason} onValueChanged={(e) => onChange("immobilizationReason",e.value)} className={classes.controlers} height={25}></TextBox>
            </InputWrapper>                  
            <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Tiempo Inmov. (días)"}>
                    <TextBox key={"immobilizationTime"} maxLength={9} name="immobilizationTime" value={dataForm?.immobilizationTime} onValueChanged={(e) => onChange("immobilizationTime",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>   
                <InputWrapper classes={classes} label={"Entrada taller"}>
                    <DateBox applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"workshopEntry"} name="workshopEntry" type="date" value={dataForm?.workshopEntry} onValueChanged={(e) => changeDate("workshopEntry", e.value)} className={classes.controlers} height={25}></DateBox>
                </InputWrapper>    
            </div>
            <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Urgente usuario taller"}>
                    <div style={{width:"30px"}}>
                        <CheckBox key={"urgent"} name="urgent" value={dataForm?.urgent?dataForm?.urgent:false} onValueChanged={(e) => changeUrgent(e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                    </div>
                </InputWrapper>
            { type === factoryProcessClaimsTemplateTypes.FACTORY_PROCESS_MAINTENANCE_CLAIM && 
                <InputWrapper classes={classes} label={"DRIVEON"}>
                    <div style={{width:"30px"}}>
                        <CheckBox key={"subtype"} name="driveon" value={dataForm?.driveOn?dataForm?.driveOn:false} onValueChanged={(e) => changeDriver(e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                    </div>
                </InputWrapper>
            }
            </div>       
            <InputWrapper classes={classes} label={"Notas"}>
                <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
            </InputWrapper>
        </div>
    )
}

export { ClaimsRequestForm };